/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type SubscriptionTypeEnum = "Expired" | "FreemiumOrg" | "LegacyPrePaywall" | "PaidBillingGroup" | "PaidOrgPro" | "PaidTeamPro" | "PaidUserPro" | "SelfServePremiumOrgQ42020" | "SelfServePremiumTeamQ12021" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type UserStatusEnum = "Active" | "Preview" | "Restricted" | "%future added value";
export type SudoModifyUser_viewer = {
    readonly id: string;
    readonly sudo: {
        readonly modifyUser: {
            readonly user: {
                readonly id: string;
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly emails: ReadonlyArray<string>;
                readonly status: UserStatusEnum | null;
                readonly externalImageUrl: string | null;
                readonly flowStates: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly flowKey: string | null;
                            readonly current: {
                                readonly id: string;
                                readonly state: string | null;
                                readonly percentComplete: number | null;
                                readonly errorMessage: string | null;
                            } | null;
                            readonly pending: {
                                readonly id: string;
                                readonly state: string | null;
                                readonly percentComplete: number | null;
                                readonly errorMessage: string | null;
                            } | null;
                        } | null;
                    } | null> | null;
                } | null;
                readonly orgs: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly id: string;
                            readonly name: string | null;
                            readonly flowStates: {
                                readonly edges: ReadonlyArray<{
                                    readonly node: {
                                        readonly id: string;
                                        readonly flowKey: string | null;
                                        readonly current: {
                                            readonly id: string;
                                            readonly state: string | null;
                                            readonly percentComplete: number | null;
                                            readonly errorMessage: string | null;
                                        } | null;
                                        readonly pending: {
                                            readonly id: string;
                                            readonly state: string | null;
                                            readonly percentComplete: number | null;
                                            readonly errorMessage: string | null;
                                        } | null;
                                    } | null;
                                } | null> | null;
                            } | null;
                        } | null;
                    } | null> | null;
                };
            } | null;
            readonly userTeams: ({
                readonly __typename: "TeamList";
                readonly list: ReadonlyArray<{
                    readonly teamId: string;
                    readonly teamName: string;
                }>;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly subscriptions: ({
                readonly __typename: "PaymentSubscriptionList";
                readonly list: ReadonlyArray<{
                    readonly id: string;
                    readonly type: SubscriptionTypeEnum | null;
                    readonly subjectUrn: {
                        readonly value: string | null;
                        readonly type: UrnType | null;
                    };
                }>;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly orgAccountingPeriod: ({
                readonly __typename: "OrgAccountingPeriod";
                readonly periodRange: {
                    readonly minDate: string;
                    readonly maxDate: string;
                };
                readonly quotaMax: number;
                readonly quotaUsed: number;
                readonly enforcementState: EnforcementStateEnum;
            } | {
                readonly __typename: "GraphEntityError";
                readonly statusCode: number | null;
                readonly message: string | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly featureStatesJson: string | null;
        } | null;
    } | null;
    readonly " $refType": "SudoModifyUser_viewer";
};
export type SudoModifyUser_viewer$data = SudoModifyUser_viewer;
export type SudoModifyUser_viewer$key = {
    readonly " $data"?: SudoModifyUser_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SudoModifyUser_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v2 = [
        (v0 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v3 = {
        "alias": null,
        "args": (v1 /*: any*/),
        "concreteType": "FlowStateConnection",
        "kind": "LinkedField",
        "name": "flowStates",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flowKey",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "flowStates(first:1000000)"
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SudoModifyUser_viewer",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Sudo",
                "kind": "LinkedField",
                "name": "sudo",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserAndExtendedInfo",
                        "kind": "LinkedField",
                        "name": "modifyUser",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "givenName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "familyName",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emails",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "status",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalImageUrl",
                                        "storageKey": null
                                    },
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": (v1 /*: any*/),
                                        "concreteType": "OrgConnection",
                                        "kind": "LinkedField",
                                        "name": "orgs",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Org",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "name",
                                                                "storageKey": null
                                                            },
                                                            (v3 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": "orgs(first:1000000)"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "userTeams",
                                "plural": false,
                                "selections": [
                                    (v4 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Team",
                                                "kind": "LinkedField",
                                                "name": "list",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "teamId",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "teamName",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "TeamList",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subscriptions",
                                "plural": false,
                                "selections": [
                                    (v4 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "PaymentSubscription",
                                                "kind": "LinkedField",
                                                "name": "list",
                                                "plural": true,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    (v5 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Urn",
                                                        "kind": "LinkedField",
                                                        "name": "subjectUrn",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "value",
                                                                "storageKey": null
                                                            },
                                                            (v5 /*: any*/)
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "PaymentSubscriptionList",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "orgAccountingPeriod",
                                "plural": false,
                                "selections": [
                                    (v4 /*: any*/),
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "DateRange",
                                                "kind": "LinkedField",
                                                "name": "periodRange",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "minDate",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "maxDate",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "quotaMax",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "quotaUsed",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "enforcementState",
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "OrgAccountingPeriod",
                                        "abstractKey": null
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "statusCode",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "message",
                                                "storageKey": null
                                            }
                                        ],
                                        "type": "GraphEntityError",
                                        "abstractKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "featureStatesJson",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '86ed5f657f1c28c1a35e1dbcdcff0978';
export default node;
